import { render, staticRenderFns } from "./WaitLoading.vue?vue&type=template&id=1079fcbc&"
import script from "./WaitLoading.vue?vue&type=script&lang=js&"
export * from "./WaitLoading.vue?vue&type=script&lang=js&"
import style0 from "./WaitLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports